import './App.css';
import AppRouting from './AppRouting';
function App() {
  return (
    <div className="App min-h-screen">
      <AppRouting />
    </div>
  );
}

export default App;
